
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.625 4h7.416L5.77 6.18c-.221.212-.185.528.08.704.266.177.66.148.88-.064l3.125-3c.024-.023.037-.051.055-.077.015-.021.033-.039.044-.062A.409.409 0 0010 3.502L10 3.5v-.002a.409.409 0 00-.046-.179c-.01-.023-.029-.041-.044-.062-.018-.026-.03-.053-.055-.077L6.73.18A.697.697 0 006.25 0a.723.723 0 00-.4.116c-.265.177-.301.492-.08.704L8.04 3H.626C.28 3 0 3.224 0 3.5s.28.5.625.5","fill":"#FD470E"}})])
          )
        }
      }
    